import React,{useState} from 'react';
import { Card, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import PageviewIcon from "@material-ui/icons/Pageview";
import { VisualizadorReportes } from './VisualizadorReportes';

const style = {
    table: {
        padding: 0, 
        margin:0, 
        boxSizing: "border-box"
    },
    iconButton: {
        width: 32,
        height: 32,
        padding: 0,
        marginTop:0,
        marginBottom:0
    }
};

export const ListaReportes = ({items}) => {
    const [abrirNuevoReporte, setAbrirNuevoReporte] = useState(false);
    const [reporte, setReporte] = useState({});
    const handleReport = (reporte) => {
    //    window.open(`${ baseUrl }/Reportes/ViewReport/${ reporte.idReporte }`);
       setReporte(reporte);
       setAbrirNuevoReporte(true);
    };

    return ( 
        <>
        <VisualizadorReportes abrirModal={abrirNuevoReporte} setAbrirModal={setAbrirNuevoReporte} reporte={reporte}/> 
        <Grid container justify="center">
            <Card>  
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">Reporte</TableCell>
                                <TableCell align="left">Descripción</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item) => (
                                <TableRow key={item.idReporte}>
                                    <TableCell align="left">
                                        <IconButton style={style.table}
                                            onClick={(e) => handleReport(item)}
                                            color="primary"
                                            aria-label="seleccionar"
                                        >
                                            <PageviewIcon style={style.iconButton} />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell align="left">
                                        {item.nombre}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item.descripcionReporte}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item.email}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
        </Grid>
        </>
     );
};
